import { RouteName } from 'src/routes/config';
import { MenuItem, MoreItem, navigateToConvertEvent, navigateToProfile, navigateToInGamePage, navigateToVestingSafe, navigateToCreatorCorner } from 'src/utils/navigate';
import { InGameCategoryKey } from 'src/utils/types';
import { MKPTab } from 'src/models';
import { CurrencyType } from '@wolffun/system-currency';
export const menuList = [{
  key: MenuItem.INVENTORY,
  name: 'Inventory',
  handlePress: () => navigateToProfile(MenuItem.INVENTORY)
}, {
  key: MenuItem.ACCOUNT_SETTINGS,
  name: 'Account Setting',
  handlePress: () => navigateToProfile(MenuItem.ACCOUNT_SETTINGS)
}, {
  key: MenuItem.WALLET,
  name: 'Wallet',
  handlePress: () => navigateToProfile(MenuItem.WALLET)
}, {
  key: MenuItem.IN_GAME,
  name: 'Ingame',
  handlePress: () => navigateToInGamePage({
    urlSearch: '',
    category: InGameCategoryKey.BattleRewards
  })
}, {
  key: MenuItem.HISTORY,
  name: 'History',
  handlePress: () => navigateToProfile(MenuItem.HISTORY)
}];
export const moreList = [{
  key: MoreItem.CONVERSION_PROGRAM,
  name: 'Conversion Program',
  pathname: RouteName.ConvertEvent,
  handlePress: () => navigateToConvertEvent()
}, {
  key: MoreItem.VESTING_SAFE,
  name: 'Vesting Safe',
  pathname: RouteName.VestingSafe,
  handlePress: () => navigateToVestingSafe()
}, {
  key: MoreItem.CREATOR_CORNER,
  name: 'Creator Corner',
  pathname: RouteName.CreatorCorner,
  handlePress: tab => {
    typeof tab === 'string' ? navigateToCreatorCorner(tab) : navigateToCreatorCorner();
  }
}];
export const moreTabCallout = [MKPTab.ConvertionProgram, MKPTab.VestingSafe, MKPTab.CreatorCorner];
export const cryptoBuy = [CurrencyType.BNB, CurrencyType.BUSDT];